// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2d8IL","log":"ModalInventoryLogs_log__1jPq_","date":"ModalInventoryLogs_date__3aVbJ","userName":"ModalInventoryLogs_userName__21zOM"};